import { combineReducers } from 'redux';
import duckHomePage, {
  DUCK_HOME_PAGE_KEY,
} from '@client/pages/homePage/duckHomePage';
import duckProfilePage, {
  DUCK_PROFILE_PAGE_KEY,
} from '@client/pages/profilePage/duckProfilePage';
import duckEventPage, {
  DUCK_EVENT_PAGE_KEY,
} from '@client/pages/eventPage/duckEventPage';
import duckIndividualFundraiserPage, {
  DUCK_INDIVIDUAL_FUNDRAISER_KEY,
} from '@client/pages/individualFundraiserPage/duckIndividualFundraiserPage';
import duckCreateIfPage, {
  DUCK_CREATE_IF_PAGE_KEY,
} from '@client/pages/createIFPage/duckCreateIfPage';
import duckDonatePage, {
  DUCK_DONATE_PAGE_KEY,
} from '@client/pages/donatePage/duckDonatePage';
import duckNotFoundPage, {
  DUCK_NOT_FOUND_KEY,
} from '@client/pages/notFoundPage/duckNotFoundPage';
import duckMemorialFundraisersPage, {
  DUCK_MEMORIAL_FUNDRAISERS_PAGE_KEY,
} from '@client/pages/memorialFundraisersPage/duckMemorialFundraisersPage';
import duckAssetsPage, {
  DUCK_ASSETS_PAGE_KEY,
} from '../pages/assetsPage/duckAssetsPage';
import faqReducer, { INDIVIDUAL_REDUCER_KEY } from './individual';
import donationReducer, { DONATION_REDUCER_KEY } from './donation';
import subscriptionReducer, { SUBSCRIPTION_REDUCER_KEY } from './subscription';
import fundraiserReducer, {
  FUNDRAISER_REDUCER_KEY,
} from './fundraiser/fundraiserReducer';
import eventReducer, { EVENT_REDUCER_KEY } from './event';
import i18nReducer, { I18N_REDUCER_KEY } from './i18n';
import commonDataReducer, { COMMON_DATA_REDUCER_KEY } from './commonData';
import userReducer, { USER_REDUCER_KEY } from './user';
import requestStateReducer, {
  REQUEST_STATE_REDUCER_KEY,
} from './requestState/requestStateReducer';

export default function createRootReducer(injectedReducers = {}, initialState) {
  const reducers = {
    [COMMON_DATA_REDUCER_KEY]: commonDataReducer,
    [DUCK_HOME_PAGE_KEY]: duckHomePage,
    [DUCK_PROFILE_PAGE_KEY]: duckProfilePage,
    [DUCK_EVENT_PAGE_KEY]: duckEventPage,
    [DUCK_INDIVIDUAL_FUNDRAISER_KEY]: duckIndividualFundraiserPage,
    [DUCK_MEMORIAL_FUNDRAISERS_PAGE_KEY]: duckMemorialFundraisersPage,
    [DUCK_CREATE_IF_PAGE_KEY]: duckCreateIfPage,
    [DUCK_DONATE_PAGE_KEY]: duckDonatePage,
    [DUCK_NOT_FOUND_KEY]: duckNotFoundPage,
    [DUCK_ASSETS_PAGE_KEY]: duckAssetsPage,
    [INDIVIDUAL_REDUCER_KEY]: faqReducer,
    [DONATION_REDUCER_KEY]: donationReducer,
    [USER_REDUCER_KEY]: userReducer,
    [SUBSCRIPTION_REDUCER_KEY]: subscriptionReducer,
    [FUNDRAISER_REDUCER_KEY]: fundraiserReducer,
    [EVENT_REDUCER_KEY]: eventReducer,
    [I18N_REDUCER_KEY]: i18nReducer,
    [REQUEST_STATE_REDUCER_KEY]: requestStateReducer,
    ...injectedReducers,
  };

  // If initialState contains state we have not loaded the reducer-code for yet,
  // make sure we preserve that state by creating an empty reducer for it
  if (initialState) {
    const reducerNames = Object.keys(reducers);
    Object.keys(initialState).forEach((initialStateKey) => {
      if (reducerNames.indexOf(initialStateKey) === -1) {
        reducers[initialStateKey] = (state = null) => state;
      }
    });
  }

  return combineReducers(reducers);
}
